import Error from 'components/alerts/Error';
import Success from 'components/alerts/Success';
import { closeModal } from 'components/modal/modules/dispatcher/methods';
import React from 'react';
import { fetchGraphQL } from 'services/graphql/GraphQL';


class PayoutConfirmation extends React.Component<{ [label: string]: any }, { [label: string]: any }> {

    constructor(props) {
        super(props)
        this.state = {
            success: false,
            error: false,
            timer: Date.now()
        }
    }

    public payout() {
        if (this.props.eventId !== undefined && this.props.eventId !== null) {
            fetchGraphQL(`
            mutation {
                event {
                    payout(eventId:"${this.props.eventId}")
                }
            }
            `).then(res => {
                if (res !== undefined && res !== null) {
                    if (res.event !== undefined && res.event !== null) {
                        if (res.event.payout !== undefined && res.event.payout !== null) {
                            if (res.event.payout === true) {
                                closeModal()
                                this.setState({
                                    timer: Date.now()
                                }, () => {
                                    while (true) {
                                        if (Date.now() - this.state.timer < 1250) {
                                            // Wait
                                        } else {
                                            break;
                                        }
                                    }
                                    window.location.reload();
                                })
                            } else {
                                this.setState({ success: false, error: true })
                            }
                        }
                    }
                }
            })
        }
    }

    public render() {
        return <div>
            {
                !this.state.error && !this.state.success ? "Are you sure you want to send payment for this event?" :
                    (this.state.error ? <Error content="An unexpected error occurred while trying to send this payout. Try again later." /> : <Success content="Payout has been initiated. Funds will be deposited into the event host's account in 2-3 business days." />)
            }
            <br /><br /><br />
            <div className="Seperate-Buttons">

                <button
                    className='new-button-white-3'
                    style={{
                        border: 'none'
                    }}
                    onClick={e => closeModal()}
                >
                    CANCEL
                    </button>


                <button
                    className='new-button-white-3'
                    style={{
                        border: 'none'
                    }}
                    onClick={e => this.payout()}
                >
                    PAYOUT
                </button>
            </div>
        </div>
    }

}

export default PayoutConfirmation;


// WEBPACK FOOTER //
// ./src/components/platform/card/modules/EventFooterControls/PayoutConfirmation.tsx